import React from 'react';

function VerticalColumn() {
  return (
<div className="vertical-column">
  <h1 className="bar-name">
    <span className="large-text">The HOLE</span> <br/>
    <span className="small-text">in the</span> <br/>
    <span className="large-text">WALL</span>
  </h1>
  <p className="bar-blurb underline">2867A Dundas Street West</p>
  <p className="bar-blurb">Open late 7 days a week</p>
  <p className="bar-blurb underline">Kitchen hours</p>
  <p className="bar-blurb">Sun - Thur 5 - 11</p>
  <p className="bar-blurb">Fri - Sat 5 - 12</p>
</div>


  );
}

export default VerticalColumn;
